import { useReduxState } from 'hooks';
import { AdminPage } from 'components/admin';
import { PageInnerContent, PageSidebar } from 'components/page';

import type { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  activeLink: string;
}

const AdminPageLogs = ({ activeLink, children }: Props) => {
  const { messages, user } = useReduxState();

  return (
    <AdminPage activeLink="/admin/events" withSidebar={true}>
      <PageSidebar
        active={activeLink}
        links={[
          {
            href: '/admin/events',
            icon: 'list' as const,
            title: messages.commonActivityLog
          },
          {
            href: '/admin/access-requests',
            icon: 'key' as const,
            title: messages.adminVuoadminLogins
          },
          ...(user?.roles?.includes('vuoadmin')
            ? [
                {
                  href: '/admin/email-log',
                  icon: 'envelope' as const,
                  title: messages.emailLog
                },
                {
                  href: '/admin/user-data-access',
                  icon: 'user' as const,
                  title: messages.adminUserDataAccessLog
                }
              ]
            : []),
          {
            href: '/admin/logins',
            icon: 'globe-americas' as const,
            title: messages.profileLoginHistory
          }
        ]}
      />

      <PageInnerContent>{children}</PageInnerContent>
    </AdminPage>
  );
};

export default AdminPageLogs;
